import angular from 'angular';
import template from './participant-screen-frame-mini.html';
import desktopActions from './desktop-actions/desktop-actions';
import { isActiveSpeakerOfGroupCall } from '../../../../modules/call/helpers';
class ParticipantScreenFrameMiniController {
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
    }
    $onInit() {
        this.$scope.$watch('$ctrl.withVideo', async () => {
            if (!this.withVideo)
                return;
            const videoElement = await this.stream.videoElementPromise;
            if (videoElement) {
                this.$element[0]
                    .getElementsByClassName('call-frames__append-video')[0]
                    .appendChild(videoElement);
            }
        });
    }
    get isHighlighted() {
        return isActiveSpeakerOfGroupCall(this.stream.stream);
    }
}
const participantScreenFrameMiniComponent = {
    template,
    bindings: {
        disabled: '<',
        withVideo: '<',
        stream: '<',
        isInGroupCall: '<',
        isVideoDisabled: '<',
        username: '<',
        onSelect: '&',
        isPinned: '<',
    },
    controller: ParticipantScreenFrameMiniController,
};
export default angular
    .module('doxy.videoChat.callFrames.participantScreenFrameMiniComponent', [
    desktopActions,
])
    .component('participantScreenFrameMini', participantScreenFrameMiniComponent)
    .name;
